import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { sendDwh } from 'reactApp/utils/ga';

import { searchTooltipData, SearchTooltipTypes } from './SearchTooltip.data';
import {
    getSessionTooltipVisibilityStatus,
    getTooltipAppearanceCount,
    getTooltipFlagName,
    increaseTooltipAppearanceCount,
    setSessionTooltipVisibilityStatus,
} from './SearchTooltip.helpers';

interface UseTooltipStateProps {
    visibilityValue: boolean;
    tooltipType: SearchTooltipTypes | null;
}

export const useTooltipState = ({ visibilityValue, tooltipType }: UseTooltipStateProps) => {
    const email = useSelector(UserSelectors.getEmail);
    const tooltipFlagName = getTooltipFlagName(email, tooltipType);
    const data = tooltipType ? searchTooltipData[tooltipType] : { title: '', description: '' };

    const sendRadar = (eventCategory) => {
        sendDwh({
            eventCategory,
            dwhData: {
                place: 'desktop',
                text_id: tooltipType,
                text: `${data.title} ${data.description}`,
            },
        });
    };

    const [isTooltipVisible, setTooltipVisibility] = useState(
        tooltipFlagName &&
            visibilityValue &&
            getSessionTooltipVisibilityStatus(tooltipFlagName, 'closed') !== 'true' &&
            (getTooltipAppearanceCount(tooltipFlagName) < 2 || getSessionTooltipVisibilityStatus(tooltipFlagName, 'visible') === 'true')
    );

    useEffect(() => {
        if (
            tooltipType &&
            getSessionTooltipVisibilityStatus(tooltipFlagName, 'closed') !== 'true' &&
            (getTooltipAppearanceCount(tooltipFlagName) < 2 || getSessionTooltipVisibilityStatus(tooltipFlagName, 'visible') === 'true')
        ) {
            setTooltipVisibility(visibilityValue);
        }
    }, [visibilityValue]);

    useEffect(() => {
        if (isTooltipVisible) {
            sendRadar('search-tooltip-show');
            if (getSessionTooltipVisibilityStatus(tooltipFlagName, 'visible') !== 'true') {
                setSessionTooltipVisibilityStatus(tooltipFlagName, 'visible');
                increaseTooltipAppearanceCount(tooltipFlagName);
            }
        }
    }, [isTooltipVisible]);

    const onTooltipClose = useCallback(() => {
        if (
            getSessionTooltipVisibilityStatus(tooltipFlagName, 'visible') === 'true' &&
            getSessionTooltipVisibilityStatus(tooltipFlagName, 'closed') !== 'true'
        ) {
            setTooltipVisibility(false);
            sendRadar('search-tooltip-close');
            setSessionTooltipVisibilityStatus(tooltipFlagName, 'closed');
        }
    }, []);

    return { isTooltipVisible, onTooltipClose };
};
